export default __webpack_public_path__ + "static/media/lines.2c092645.svg";